// extracted by mini-css-extract-plugin
export var button = "_mz-2";
export var card = "_mz-0";
export var closeButtonContainer = "_mz-3";
export var iconContainer = "_mz-1";